{
  "version": "1.0.0.0",
  "title": "[resource('entities/feedback/_title/singular')]",
  "form": {
    "layout": {
      "pages": [
        {
          "label": "[resource('entities/feedback/contact')]",
          "sections": [
            {
              "location": "full",
              "groups": [
                {
                  "label": "[resource('entities/feedback/contact')]",
                  "controls": [
                    {
                      "label": "[resource('entities/feedback/name')]",
                      "fieldName": "name",
                      "type": "TextBoxComponent",
                      "validators": [
                        {
                          "name": "notNullOrEmpty"
                        }
                      ]
                    },
                    {
                      "label": "[resource('entities/feedback/email')]",
                      "fieldName": "email",
                      "type": "TextBoxComponent",
                      "validators": [
                        {
                          "name": "notNullOrEmpty"
                        },
                        {
                          "name": "email"
                        }
                      ]
                    }
                  ]
                },
                {
                  "label": "[resource('entities/feedback/feedback')]",
                  "controls": [
                    {
                      "fieldName": "description",
                      "type": "HtmlEditorComponent",
                      "validators": [
                        {
                          "name": "notNullOrEmpty"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  }
}